<template>
  <div :id="'amplitude-' + htmlId" class="amplitude"></div>
</template>

<script>
export default {
  name: "amplitude",

  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    htmlId() {
      return this.id.replaceAll(" ", "-");
    },
  },

  created() {
    this.$store.dispatch("logLandingVisit", this.id);

    console.log('this.id', this.id);

    if (this.id === "earth-hour") {
      this.$store.dispatch("logEarthHourVisit", {
        id: this.id,
        eventName: 'EH homepage viewed'
      });
    }
    if (this.id === "earth-hour-register") {
      this.$store.dispatch("logEarthHourVisit", {
        id: this.id,
        eventName: 'EH registration page viewed'
      });
    }
  },
  mounted() {
    if (this.id == "ra hub") {
      // Attach amplitude event for product clicks
      const cards = $(".ra-hub-cards a");
      cards.click({ callback: this.logProductClick }, function (e) {
        e.preventDefault();
        try {
          // Extract link filename for id
          const paths = this.pathname.split("/");
          const id = paths[paths.length - 1] || paths[paths.length - 2];
          e.data.callback({ id, link: this.href });
        } catch (err) {
          console.error(err);
        }
      });
    }

    // Attach amplitude event for FAQ clicks
    if (["native adoption", "international adoption"].includes(this.id)) {
      $("#faq .faq-accordian a").click(
        { callback: this.logFaqClick },
        function (e) {
          e.preventDefault();
          try {
            const faqTitle = $(this).text();
            e.data.callback(faqTitle);
          } catch (err) {
            console.error(err);
          }
        }
      );
    }

    if (this.id === "earth-hour") {
      $("a.eh-down").click({ callback: this.logDownArrow }, function (e) {
        e.preventDefault();
        try {
          e.data.callback(this.href);
        } catch (err) {
          console.error(err);
        }
      });
    }
  },

  methods: {
    logProductClick({ id, link }) {
      this.$store
        .dispatch("logProductLink", { id, link })
        .then(() => (window.location.href = link));
    },
    logFaqClick(faq) {
      this.$store.dispatch("logFaq", faq);
    },
    logDownArrow(link) {
      this.$store.dispatch("logEarthHourDownArrow", link);
    },
  },
};
</script>


// WEBPACK FOOTER //
// Amplitude.vue?1a0a84db